import React from "react";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../LocalizedLink/LocalizedLink";
import Events from "../../api/events";
import { splitEvents } from "../../utils/events";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import icon1 from "../../images/event/time.svg";
import icon2 from "../../images/event/pin.svg";
import { Image } from "@imagekit/react";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const settings = {
  dots: false,
  arrows: true,
  loop: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  rtl: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
};

const EventCard = ({ event, t }) => (
  <div className="event-single-card">
    <div className="image">
      <Image
        src={event.elImg}
        alt=""
        transformation={[
          {
            width: "590",
            height: "740",
            crop: "maintain_ratio",
            focus: "auto",
          },
        ]}
      />
    </div>
    <div className="content">
      <h2 className="title">
        <LocalizedLink
          onClick={ClickHandler}
          to={`/event-single/${event.slug}`}
        >
          {t(`events:items.${event.slug}.title`)}
        </LocalizedLink>
      </h2>
      <ul>
        <li>
          <img src={icon1} alt="icon" />{" "}
          {t(`events:items.${event.slug}.date`)}
          {event.time ? ` @ ${event.time}` : ""}{" "}
        </li>
        <li>
          <img src={icon2} alt="icon" />
          {t(`events:items.${event.slug}.location`)}
        </li>
      </ul>
    </div>
  </div>
);

// Fewer than three cards look broken inside the slider, so they are laid out
// as a plain centered row instead.
const EventList = ({ events, t }) =>
  events.length >= 3 ? (
    <Slider {...settings}>
      {events.map((event) => (
        <div key={event.slug}>
          <EventCard event={event} t={t} />
        </div>
      ))}
    </Slider>
  ) : (
    <div className="row g-4 justify-content-center">
      {events.map((event) => (
        <div className="col-lg-4 col-md-6 col-12" key={event.slug}>
          <EventCard event={event} t={t} />
        </div>
      ))}
    </div>
  );

// `showPast` is used on the activities page; the homepage only announces what
// is still ahead.
const EventSectionS2 = ({ showPast = false }) => {
  const { t } = useTranslation(["home", "events"]);
  const { upcoming, past } = splitEvents(Events);

  return (
    <section className="event-section-s2 section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8 col-12">
            <div className="section-title">
              <h2>{t("home:events.title")}</h2>
              <h3>{t("home:events.subtitle")}</h3>
            </div>
          </div>
        </div>

        <div className="event-slider">
          {upcoming.length > 0 ? (
            <EventList events={upcoming} t={t} />
          ) : (
            <p className="event-empty">{t("events:upcoming.empty")}</p>
          )}
        </div>

        {showPast && past.length > 0 && (
          <div className="past-events">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 col-12">
                <div className="section-title">
                  <h3>{t("events:past.title")}</h3>
                </div>
              </div>
            </div>
            <EventList events={past} t={t} />
          </div>
        )}
      </div>
    </section>
  );
};

export default EventSectionS2;
